import axios from 'axios'
import env from '../../utils/env'

const sessionManagerBaseUrl = env.SESSION_MANAGER_BASE_URL;
const apiClient = axios.create({
  baseURL: sessionManagerBaseUrl
})

export default class insights {
  static async getNumbers() {
    return apiClient
      .get('/v2/analytics/numbers')
      .then((response) => {
        if (response) {
          return response.data.data
        }
        return false
      })
      .catch((err) => console.log(err))
  }

  static async getAccounts() {
    return apiClient
      .get('/v2/analytics/accounts/?per_page=1000&page=1')
      .then((response) => {
        if (response) {
          return response.data.data
        }
        return false
      })
      .catch((err) => console.log(err))
  }

  static async getAccountData({ params }) {
    return apiClient({
      url: `/bots/${localStorage.getItem('botId')}/account`,
      method: 'get',
      params: {
        ...params
      }
    })
      .then((response) => {
        if (response) {
          return response.data
        }
        return false
      })
      .catch((err) => console.log(err))
  }

  static async consumptionPerDay({ params }) {
    return apiClient({
      url: `sessions/daily-consumption`,
      method: 'get',
      params: {
        bot_id: localStorage.getItem('botId'),
        ...params
      }
    })
      .then((response) => {
        if (response) {
          return response.data.data
        }
        return false
      })
      .catch((err) => console.log(err))
  }

  static async channelsConsumptionPerDay({ params }) {
    return apiClient({
      url: `/sessions/daily-consumption/detailed`,
      method: 'get',
      params: {
        ...params,
        bot_id: localStorage.getItem('botId'),
      }
    })
      .then((response) => {
        if (response) {
          return response.data.data
        }
        return false
      })
      .catch((err) => {
        console.log(err)
        return false
      })
  }

  static async getAccountAverageData(id, { params }) {
    // console.log(params)
    return apiClient({
      url: `/messages/charts`,
      method: 'get',
      params: {
        ...params,
        bot_id: localStorage.getItem('botId'),
      }
    })
      .then((response) => {
        if (response) {
          return response.data
        }
        return false
      })
      .catch((err) => {
        console.log(err)
        return false
      })
  }
}
